import { buildModelManager } from "../builder.js";
const DefaultUnmatchedCategoryLogSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  occurrences: true,
  rawValue: true,
  resolved: true,
  sourceField: true,
  updatedAt: true
};
const modelApiIdentifier = "unmatchedCategoryLog";
const pluralModelApiIdentifier = "unmatchedCategoryLogs";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultUnmatchedCategoryLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultUnmatchedCategoryLogSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUnmatchedCategoryLogSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUnmatchedCategoryLogSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultUnmatchedCategoryLogSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultUnmatchedCategoryLogSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultUnmatchedCategoryLogSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createUnmatchedCategoryLog",
    operationReturnType: "CreateUnmatchedCategoryLog",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      unmatchedCategoryLog: { required: false, type: "CreateUnmatchedCategoryLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUnmatchedCategoryLogSelection
  },
  {
    type: "action",
    operationName: "bulkCreateUnmatchedCategoryLogs",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateUnmatchedCategoryLogsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultUnmatchedCategoryLogSelection
  },
  {
    type: "action",
    operationName: "updateUnmatchedCategoryLog",
    operationReturnType: "UpdateUnmatchedCategoryLog",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      unmatchedCategoryLog: { required: false, type: "UpdateUnmatchedCategoryLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUnmatchedCategoryLogSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateUnmatchedCategoryLogs",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateUnmatchedCategoryLogsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultUnmatchedCategoryLogSelection
  },
  {
    type: "action",
    operationName: "deleteUnmatchedCategoryLog",
    operationReturnType: "DeleteUnmatchedCategoryLog",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteUnmatchedCategoryLogs",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertUnmatchedCategoryLog",
    operationReturnType: "UpsertUnmatchedCategoryLog",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      unmatchedCategoryLog: { required: false, type: "UpsertUnmatchedCategoryLogInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateUnmatchedCategoryLogResult": { hasReturnType: false },
      "... on UpdateUnmatchedCategoryLogResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultUnmatchedCategoryLogSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertUnmatchedCategoryLogs",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertUnmatchedCategoryLogsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultUnmatchedCategoryLogSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "unmatchedCategoryLogGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const UnmatchedCategoryLogManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultUnmatchedCategoryLogSelection,
  operations
);
export {
  DefaultUnmatchedCategoryLogSelection,
  UnmatchedCategoryLogManager
};
//# sourceMappingURL=UnmatchedCategoryLog.js.map
